module.exports = require("@comparaonline/ui-forms-validators/dist/validators/commons/date/minAge");